var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeminar = function SvgSeminar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "seminar_svg__st0",
    d: "M21.1 0H2.9C1.3 0 0 1.3 0 2.9v18.3C0 22.7 1.3 24 2.9 24h18.3c1.6 0 2.9-1.3 2.9-2.9V2.9C24 1.3 22.7 0 21.1 0zM12 20.5c-4.7 0-8.5-3.8-8.5-8.5S7.3 3.5 12 3.5s8.5 3.8 8.5 8.5-3.8 8.5-8.5 8.5z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "seminar_svg__st0",
    cx: 14.4,
    cy: 9.1,
    r: 2.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "seminar_svg__st0",
    d: "M17.6 16.5v-.7c0-1.6-1.4-2.9-3.2-2.9h-.7s-1.4.3-2.7 0c-.9-.3-1.4-.5-2.1-1l-1-4.3c-.1-.4-.5-.6-.8-.5-.4.1-.6.4-.5.8l.9 3.6c-.3.1-.5.3-.7.5-.5.6-.4 1.5.2 2 1.1.9 1.9 1.3 3.3 1.7h.1c.2.1.8.3.9.6v2.9h.7c2.3 0 4.3-1 5.6-2.7z"
  })));
};
export default SvgSeminar;